<template>
  <v-app class="mainApp">
    <v-main style="padding-top: 0px !important; margin-bottom: 50px">
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>

    <Footer />
  </v-app>
</template>

<script>
import Footer from './footer';
export default {
  name: 'Layout',
  components: {
    Footer,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
}
@media (min-width: 700px) {
  .container {
    max-width: 100%;
  }
}

.mainApp {
  /* background-color: violet !important; */
}
</style>
